<template>
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <!-- <v-btn class="success" v-on="on"> -->
      <v-icon
        left
        v-on="on"
        small
        title="View"
        color="success"
        @click="fetchAgentMembers"
      >
        visibility
      </v-icon>
      <!-- </v-btn> -->
    </template>
    <v-card>
      <!-- <v-card-title>
        <v-icon left>group</v-icon>
        <span class="headline">Team Details</span>
      </v-card-title> -->
      <v-toolbar>
        <v-toolbar-title>
          <v-icon left>group</v-icon>
          Agent Details
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon large color="error">close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- <pre>{{ agentMembers }}</pre> -->
      <v-card-text class="py-0">
        <v-container grid-list-sm>
          <v-layout align-center justify-space-between row fill-height>
            <v-flex sm9>
              <h1>{{ agentDetails.name }}</h1>
              <br />
              <v-layout>
                <v-flex sm3><h3>Agent ID</h3></v-flex>
                <v-flex sm3><h3>Code</h3></v-flex>
                <v-flex sm3><h3>Number of Members</h3></v-flex>
              </v-layout>
              <v-layout class="mt-2">
                <v-flex sm3>
                  <p>
                    {{ agentDetails.id }}
                  </p>
                </v-flex>
                <v-flex sm3>
                  <div class="d-inline-flex">
                    {{ agentDetails.code }}
                    <CopyToClickboard :text="agentDetails.code" />
                  </div>
                </v-flex>
                <v-flex sm3>
                  <p>
                    <span title="Available">
                      {{ agentDetails.agent_groups_count }}
                    </span>
                    |
                    <span title="Max Agents">
                      {{ agentDetails.numbers_of_agent }}
                    </span>
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm3>
              <div class="text-xs-right">
                <AddAgentMemberDialog
                  :code="agentDetails.code"
                  @result="showMessage"
                />
              </div>
            </v-flex>
          </v-layout>
          <br />
          <v-layout>
            <v-flex sm12>
              <v-card class="pa-2">
                <v-tabs v-model="active" slider-color="#f66">
                  <v-tab class="pl-3">
                    Active ({{
                      agentMembers.filter(
                        (agent) =>
                          agent.active_status === 1 &&
                          agent.verification_status === 1
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Inactive ({{
                      agentMembers.filter((agent) => agent.active_status === 0)
                        .length
                    }})
                  </v-tab>
                  <v-tab>
                    Pending ({{
                      agentMembers.filter(
                        (agent) =>
                          agent.agent_agreement === 1 &&
                          agent.verification_status === 0
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Awaiting Approval ({{
                      agentMembers.filter(
                        (agent) =>
                          agent.agent_agreement === 0 &&
                          agent.verification_status === 1
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Rejected ({{
                      agentMembers.filter(
                        (agent) => agent.verification_status == 2
                      ).length
                    }})
                  </v-tab>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseAgent
                      :loading="loading"
                      :agentMembers="
                        agentMembers.filter(
                          (agent) =>
                            agent.active_status === 1 &&
                            agent.verification_status === 1
                        )
                      "
                      status="active"
                      @refetch="fetchAgentMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseAgent
                      :loading="loading"
                      :agentMembers="
                        agentMembers.filter(
                          (agent) => agent.active_status === 0
                        )
                      "
                      status="inactive"
                      @refetch="fetchAgentMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseAgent
                      :loading="loading"
                      :agentMembers="
                        agentMembers.filter(
                          (agent) =>
                            agent.agent_agreement === 1 &&
                            agent.verification_status === 0
                        )
                      "
                      status="pending"
                      @refetch="fetchAgentMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseAgent
                      :loading="loading"
                      :agentMembers="
                        agentMembers.filter(
                          (agent) =>
                            agent.agent_agreement === 0 &&
                            agent.verification_status === 1
                        )
                      "
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseAgent
                      :loading="loading"
                      :agentMembers="
                        agentMembers.filter(
                          (agent) => agent.verification_status == 2
                        )
                      "
                    />
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ message }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  import AddAgentMemberDialog from "./AddAgentMemberDialog";
  import StatuswiseAgent from "./StatuswiseAgent";
  import CopyToClickboard from "../CopyToClickboard";
  export default {
    components: { AddAgentMemberDialog, StatuswiseAgent, CopyToClickboard },
    props: ["agentDetails", "maximumNumberOfAgentMembers"],
    data() {
      return {
        loading: false,
        dialog: false,
        active: 0,
        newAgent: null,
        agentMembers: [],
        color: "",
        message: "",
        snackbar: false,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.initialize();
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      async initialize() {
        this.newAgent = { ...this.agentDetails };
      },
      async fetchAgentMembers() {
        this.loading = true;
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            `agent.group.members-status/${this.newAgent.id}`
          );
          this.agentMembers = data.data.agents;
        } catch (error) {
          //
        }
        this.loading = false;
      },
      close() {
        this.dialog = false;
      },
      showMessage(event) {
        this.color = event[1];
        this.message = event[0];
        this.snackbar = true;
        if (this.color == "success") {
          this.fetchAgentMembers();
          this.active = 3;
        }
      },
    },
  };
</script>
